import { PartnerSwitcherType } from '@common/react/partnerships';

class LocalStorageWrapper {
    getItem<V = any>(key: string): V | undefined {
        if (typeof window === 'undefined') return;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : undefined;
        } catch (e) {
            console.log(e);
            return;
        }
    }

    setItem<V = any>(key: string, value: V) {
        if (typeof window === 'undefined') return;
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            console.log(e);
            return;
        }
    }
}

const localStorage = new LocalStorageWrapper();

export default localStorage;

// Individual named helpers

// Privacy mode

export const PRIVACY_MODE_KEY = 'privacyModeEnabled';

export const getPrivacyModeEnabled = (): boolean | undefined => {
    return localStorage.getItem<boolean>(PRIVACY_MODE_KEY);
};

export const setPrivacyModeEnabled = (enabled: boolean) => {
    localStorage.setItem(PRIVACY_MODE_KEY, enabled);
};

// Nav partner switcher

export const NAV_PARTNER_SWITCHER_TYPE = 'navPartnerSwitcherType';

export const getNavPartnerSwitcherType = (): PartnerSwitcherType => {
    const value = localStorage.getItem<unknown>(NAV_PARTNER_SWITCHER_TYPE);
    return value === 'MINE' || value === 'SHARED' || value === 'THEIRS'
        ? value
        : 'MINE';
};

export const setNavPartnerSwitcherType = (type: PartnerSwitcherType) => {
    localStorage.setItem(NAV_PARTNER_SWITCHER_TYPE, type);
};
